import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import App from './App';
import * as serviceWorker from './serviceWorker';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import { Row, Col } from 'react-bootstrap';
import Container from 'react-bootstrap/Container'
import Navbar from './Navbar.js'

ReactDOM.render(
  <Router>
    <React.StrictMode>
      <Container className="App">  {/* Removed fluid to contain width */}
        <Row className="justify-content-center">
          <Col xs={12} md={8}>  {/* Reduced column width */}
            <Navbar />
          </Col>
        </Row>
        <App />
      </Container>
    </React.StrictMode>
  </Router>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
